var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cell.isVisible
    ? _c(
        "td",
        {
          class: _vm.cell.className,
          style: _vm.getCellStyle(),
          attrs: { title: _vm.cell.getTitle(), colspan: _vm.cell.colSpans },
          on: {
            focusin: function ($event) {
              return _vm.cell.focusIn()
            },
          },
        },
        [
          _vm.cell.isErrorsCell
            ? _c("survey-errors", { attrs: { element: _vm.cell.question } })
            : _vm._e(),
          _vm._v(" "),
          _vm.cell.isActionsCell
            ? _c("sv-action-bar", {
                attrs: { model: _vm.cell.item.getData(), handleClick: false },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.cell.hasPanel
            ? _c(_vm.getComponentName(_vm.cell.panel), {
                tag: "component",
                attrs: {
                  question: _vm.cell.panel,
                  css: _vm.question.cssClasses,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.cell.showResponsiveTitle
            ? _c(
                "span",
                { class: _vm.cell.responsiveTitleCss },
                [
                  _c("survey-string", {
                    attrs: { locString: _vm.cell.responsiveLocTitle },
                  }),
                  _vm._v(" "),
                  _c("survey-matrixheaderrequired", {
                    attrs: {
                      column: _vm.cell.column,
                      question: _vm.cell.matrix,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cell.hasQuestion
            ? _c(
                "div",
                { class: _vm.cell.cellQuestionWrapperClassName },
                [
                  !_vm.cell.isChoice && _vm.cell.question.isDefaultRendering()
                    ? _c(_vm.getComponentName(_vm.cell.question), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isVisible,
                            expression: "isVisible",
                          },
                        ],
                        tag: "component",
                        attrs: { question: _vm.cell.question },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.cell.isChoice && !_vm.cell.question.isDefaultRendering()
                    ? _c(_vm.cell.question.getComponentName(), {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isVisible,
                            expression: "isVisible",
                          },
                        ],
                        tag: "component",
                        attrs: { question: _vm.cell.question },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cell.isRadio
                    ? _c("survey-radiogroup-item", {
                        key: _vm.cell.item.value,
                        attrs: {
                          question: _vm.cell.question,
                          item: _vm.cell.item,
                          hideLabel: true,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cell.isCheckbox
                    ? _c("survey-checkbox-item", {
                        key: _vm.cell.item.value,
                        attrs: {
                          question: _vm.cell.question,
                          item: _vm.cell.item,
                          hideLabel: true,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cell.isOtherChoice
                    ? _c("survey-other-choice", {
                        attrs: { question: _vm.cell.question },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.cell.hasTitle
            ? _c("survey-string", { attrs: { locString: _vm.cell.locTitle } })
            : _vm._e(),
          _vm._v(" "),
          !!_vm.getRequiredText() && _vm.cell.hasTitle
            ? _c("span", { class: _vm.question.cssClasses.cellRequiredText }, [
                _vm._v(_vm._s(_vm.getRequiredText())),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }